<template>
    <div class="search-container">
        <el-autocomplete ref="autocompleteRef" v-model="searchText" @blur="handleSelect"
            :fetch-suggestions="showSuggestions ? querySearch : emptyFetchSuggestions" placeholder="请输入企业名称关键词搜索"
            value-key="value" :trigger-on-focus="false" @select="handleSelect">
        </el-autocomplete>

        <el-button class="search-btn" :loading="loading" @click="handleSearch">
        {{loading ? '搜索中...' : '搜索'}}
        </el-button>
    </div>
</template>

<script>

export default {
    data() {
        return {
            searchText: '',
            loading: false,
            showSuggestions: false,
            backendData: [],
            userdata:{},
        }
    },
    created() {
        this.userdata = this.getuseriformation();
    },
    methods: {
        // 空函数
        emptyFetchSuggestions(queryString, cb) {
            cb([])
        },

        // 搜索建议函数
        querySearch(queryString, cb) {
            if (!queryString || queryString.trim() === '') {
                cb([])
                return
            }

            if (this.backendData.length > 0) {
                const results = this.backendData.filter(item =>
                    item.value.toLowerCase().includes(queryString.toLowerCase())
                )
                cb(results)
            } else {
                cb([])
            }
        },

        // 点击搜索按钮
        async handleSearch() {
            if (!this.searchText.trim()) {
                this.$message.warning('请输入搜索内容')
                return
            }

            this.loading = true;

            try {
                // 1. 调用后台接口
                const response = await this.callSearchAPI(this.searchText);
                this.backendData = this.formatBackendData(response.list);
                // console.log('格式化后的数据:', this.backendData);
                // 2. 启用建议显示
                this.showSuggestions = true

                // 3. 关键：手动触发下拉框显示
                this.$nextTick(() => {
                    this.triggerDropdown()
                })

            } catch (error) {
                this.$message.error('搜索失败')
                this.showSuggestions = false
            } finally {
                this.loading = false
            }
        },

        // 手动触发下拉框显示（关键方法）
        triggerDropdown() {
            const autocomplete = this.$refs.autocompleteRef
            if (!autocomplete) return

            // 方法1：直接调用组件的内部方法
            if (autocomplete.handleFocus) {
                autocomplete.handleFocus()
            }

            // 方法2：通过DOM操作触发focus
            const input = autocomplete.$el.querySelector('input')
            if (input) {
                // 先blur再focus，确保触发下拉
                input.blur()
                setTimeout(() => {
                    input.focus()
                }, 100)
            }

            // 方法3：强制更新建议列表
            if (autocomplete.suggestions) {
                autocomplete.suggestions = this.backendData
                autocomplete.activated = true
            }
        },

        // 模拟API调用
        async callSearchAPI(keyword) {
            console.log('调用API搜索关键词:', keyword);
            return new Promise((resolve) => { 
                    // this.loading = true;
                    let ajaxurl = this.$api.cyl.search.enterprise();
                    $.ajax({
					type:"POST",
					url:this.$api.cyl.search.enterprise(),
					data:{kw:keyword},
					headers:{AuthToken:this.userdata.token },
					success:function(res){  
						 console.log('企业列表', res); 
						 if (res.success) {
                            resolve(res);
						 } else {
						 	
						 }
					} 
				})  
            })
        },

        // 格式化数据
        formatBackendData(backendData) {
            if ( backendData) {
                return backendData.map(item => ({
                    value: item.title,
                    id: item.stockCode,
                    rawData: item
                }))
            }
            return []
        },

        handleSelect(item) {
            console.log('选中项:', item);
            // this.searchText = item.value;
            this.$emit('select', this.searchText);
        }
    }
}
</script>

<style scoped lang="scss">
.search-container {
    display: flex;
    align-items: center;
    width: 400px;
}

:deep(.el-autocomplete) {
    flex: 1;
}
::v-deep{
    &.el-autocomplete{
        width: 800px;
    }
}

:deep(.el-autocomplete .el-input__inner) {
    border: 1px solid #a0cfff;
    border-radius: 4px;
}

.search-btn {
    background-color: #4c99ff;
    border-color: #4c99ff;
    color: #ffffff;
    margin-left: 10px;
    height: 40px;
}
</style>